<template>
    <ul class="nav-boards-wrapper normal-text" :class="{'in-board': inBoard}">
        <template v-if="all_data_loaded">
            <nav-board v-for="board in mainBoards" :key="board.id" :board="board" :boards="boards"></nav-board>
        </template>
        <template v-else>
            <div class="tw-inline-flex">
                <i class="far fa-spinner fa-spin light-text"></i>
            </div>
        </template>
    </ul>
</template>

<script>
    import {mapState} from 'vuex';
    import NavBoard from "./NavBoard.vue";
    import Channel from "@/resources/assets/js/vue/lib/models/Channel";

    export default {
        name: 'NavBoards',

        components: {
            'nav-board': NavBoard
        },

        props: {
            in_board: {
                required: true,
                type: String,
            },
        },

        computed: {
            ...mapState('db/channels',
                ['all_data_loaded']),

            boards() {
                return Channel.all();
            },

            mainBoards() {
                return Channel.query().where('subgroup_id', null).where('template', 'default').where('source', 'system').orderBy('index').get();
            },

            inBoard() {
                return this.in_board === 'true';
            },
        },

        updated() {
            if(typeof stickySidebar !== 'undefined') {
                stickySidebar.init();
            }
        },

		watch: {
            all_data_loaded(val) {
				if (val === true) {
					this.$nextTick(() => Notifier.updateHTML());
				}
			},
		},
    };
</script>